import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { Dimensions, Serie } from '../../../models';

@Component({
    selector: '[aaColumnGroup]',
    templateUrl: './column-group.component.html',
    styleUrls: [
        './column-group.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColumnGroupComponent implements OnInit
{
    @Input() dimensions: Dimensions;
    @Input() serie: Serie;

    constructor ()
    { }

    ngOnInit ()
    {
    }
}
